import api from './api';

export function startAdaptiveTest(testId) {
    return api.post(`/adaptive-tests/${testId}/start`);
}

export function submitAdaptiveAnswer(sessionId, answerId) {
    return api.post(`/adaptive-tests/${sessionId}/answer`, { answer_id: answerId });
}

export function getAdaptiveResult(sessionId) {
    return api.get(`/adaptive-tests/${sessionId}/result`);
}
